<template>
  <b-card
    :class="{panelHover: hover && !panelconfig.noHover}"
    no-body
    style="height: 100%; width: 100%; padding: 0;"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <b-col
      v-if="panelconfig.noHover"
      class="text-left"
    />
    <b-card-title
      v-if="!panelconfig.noHover"
      class="ml-2 mt-2"
    >
      Statistic Card Horizontal
    </b-card-title>

    <!-- Meta Info -->
    <div
      v-if="panelconfig.noHover"
      class="d-flex mt-1 small text-muted "
    >
      <b-col
        class="text-left"
      >
        <feather-icon
          size="15"
          icon="CpuIcon"
        />
        {{ panelconfig.dataSources[0].dataSource.name }}

      </b-col>
      <b-col
        class="text-right"
        @click="showInfo = !showInfo"
      >
        <feather-icon
          size="15"
          icon="InfoIcon"
        />
      </b-col>
    </div>

    <!-- Statistic -->
    <div class="m-1 d-flex justify-content-between align-items-center">
      <div class="truncated">
        <h2 class="mb-25 font-weight-bolder">
          {{ statisticValue + ' ' + statisticUnit }}
        </h2>
        <span>{{ dataFieldName }}</span>
      </div>
      <b-avatar
        :variant="`light-${color}`"
        size="45"
      >
        <feather-icon
          size="21"
          :icon="icon"
        />
      </b-avatar>
    </div>
    {{ panelconfig }}
    <!-- Footer -->
    <div
      v-if="panelconfig.noHover"
      class="d-flex mb-1 small text-muted"
    >
      <b-col
        class="text-left"
      >

        <feather-icon
          size="16"
          icon="ClockIcon"
        />
        {{ timestamp }}
      </b-col>
    </div>

  </b-card>
</template>

<script>
import {
  BCol,
  BCard,
  BAvatar,
  BCardTitle,
} from 'bootstrap-vue'
import { API } from 'aws-amplify'
import * as queries from '../../../../../graphql/queries'

export default {
  components: {
    BCard,
    BCol,

    BAvatar,
    BCardTitle,

  },
  props: {
    panelconfig: {
      type: Object,
      default: () => ({
        dataSources: [],
        icon: {
          title: '',
          id: '',
        },
        color: '',
        hover: false,
      }),
    },
  },
  data() {
    return {
      hover: false,
      statistic: '',
      timestamp: '',
      showInfo: false,
    }
  },
  computed: {
    title: {
      get() {
        if (this.panelconfig.dataSources[0].dataField !== undefined) {
          return this.panelconfig.dataSources[0].dataField.name
        }
        return 'CPU Usage'
      },
      set(value) {
        this.panelconfig.statisticTitle = value
      },
    },
    dataSourceName() {
      if (this.panelconfig.dataSources.length > 0) {
        return this.panelconfig.dataSources[0].name
      }
      return 'Data Source'
    },
    dataFieldName() {
      if (this.panelconfig.dataSources.length > 0 && 'dataField' in this.panelconfig.dataSources[0]) {
        return this.panelconfig.dataSources[0].dataField.name
      }
      return 'CPU Usage'
    },

    statisticValue() {
      if (this.panelconfig.dataSources.length > 0 && 'dataField' in this.panelconfig.dataSources[0]) {
        return this.statistic
      }

      return '89'
    },
    statisticUnit() {
      if (this.statistic !== '') {
        if (this.panelconfig.dataSources.length > 0 && 'dataField' in this.panelconfig.dataSources[0]) {
          return this.panelconfig.dataSources[0].dataField.unit
        }
      }
      return '%'
    },
    icon: {
      get() {
        if (this.panelconfig.icon) {
          return this.panelconfig.icon.id
        }
        return 'CpuIcon'
      },
      set(value) {
        this.panelconfig.icon = value
      },
    },
    color: {
      get() {
        if (this.panelconfig.color) {
          return this.panelconfig.color
        }
        return 'primary'
      },
      set(value) {
        this.panelconfig.color = value
      },
    },
  },
  watch: {
    panelconfig: {
      handler(newVal) {
        if (this.panelconfig.dataSources.length > 0 && 'dataField' in this.panelconfig.dataSources[0]) {
          this.getData(newVal)
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.panelconfig.dataSources.length > 0 && 'dataField' in this.panelconfig.dataSources[0]) {
      this.getData(this.panelconfig)
    }
  },
  methods: {
    async getData(panelconfig) {
      this.statistic = 'Loading...'
      this.time = 'Loading...'
      const workspace = JSON.parse(localStorage.getItem('workspace')).id
      const getWorkspaceResponse = await API.graphql({
        query: queries.getWorkspace,
        variables: {
          id: workspace,
        },
      })
      this.workspacetoken = getWorkspaceResponse.data.getWorkspace.workspacetoken
      const db = getWorkspaceResponse.data.getWorkspace.id
      const table = panelconfig.dataSources[0].dataSource.deviceModelDevicesId
      const apiName = 'TimestreamAPI'
      const path = '/items'
      const query = `SELECT * FROM "${db}"."${table}" where id = '${panelconfig.dataSources[0].dataSource.id}' and measure_name = '${panelconfig.dataSources[0].dataField.identifier}' ORDER BY time DESC LIMIT 1`
      const myInit = {
        headers: {
          workspace,
          workspacetoken: this.workspacetoken,
        },
        queryStringParameters: {
          query,
        },
      }
      const response = await API.get(apiName, path, myInit)
      // eslint-disable-next-line prefer-destructuring, camelcase, no-undef
      this.statistic = response.timestreamData[0][0]['measure_value::double']
      this.timestamp = response.timestreamData[0][0].time
    },
  },
}
</script>
<style lang="scss">
.panelHover {
  position: relative;
   width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(45, 177, 85, 0.153); /* Black background with opacity */
  z-index: 0; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
</style>
